import { AuditsType } from 'app/types/User';

export const mockAudits: AuditsType = [
  {
    key: 'cb5f8cbf-571d-4328-abd2-ec13ea3a73b1',
    type: 'client',
    action: 'create',
    data: {
      email: {
        old: 'aa@aa.com',

        new: 'aa1@aa.com',
      },

      name: {
        old: 'Ahmed',

        new: 'Ali',
      },
      age: {
        old: '5',

        new: '6',
      },
    },
    creator: { key: '1' },
    client: { key: '1' },
    user: { key: '1' },
    requestInstanceKey: { key: '1' },
    productInstanceKey: { key: '1' },
    createdAt: '2023-04-02T08:56:42.000Z',

    updatedAt: '2023-04-02T08:56:42.000Z',
  },
  {
    key: '8fbb7c8a-7272-4868-9711-3c3ba778a1da',
    type: 'user',
    action: 'edit',
    data: {
      name: {
        old: 'Omar',
        new: '',
      },
    },

    creator: { key: '1' },
    client: { key: '1' },
    user: { key: '1' },
    requestInstanceKey: { key: '1' },
    productInstanceKey: { key: '1' },
    createdAt: '2023-04-02T08:56:42.000Z',

    updatedAt: '2023-04-02T08:56:42.000Z',
  },
  {
    key: '95c8c344-a452-48d3-a104-239aaa0c8405',
    type: 'request instance',
    action: 'invoke',
    data: {
      name: {
        old: 'Omar',

        new: 'Moutasem',
      },
    },
    creator: { key: '1' },
    client: { key: '1' },
    user: { key: '1' },
    requestInstanceKey: { key: '1' },
    productInstanceKey: { key: '1' },
    createdAt: '2023-04-02T08:56:42.000Z',

    updatedAt: '2023-04-02T08:56:42.000Z',
  },
  {
    key: 'c256d7db-88e5-4128-8bac-4fc5b39fb36f',
    type: 'product instance',
    action: 'edit',
    data: {
      email: {
        old: 'aa@aa.com',

        new: 'aa1@aa.com',
      },

      name: {
        old: 'Ahmed',

        new: 'Ali',
      },
      age: {
        old: '5',

        new: '6',
      },
    },
    creator: { key: '1' },
    client: { key: '1' },
    user: { key: '1' },
    requestInstanceKey: { key: '1' },
    productInstanceKey: { key: '1' },
    createdAt: '2023-04-02T08:56:42.000Z',

    updatedAt: '2023-04-02T08:56:42.000Z',
  },
];

// export const mockAudits: Audit[] = [
//   {
//     key: '0',

//     type: 'client',

//     action: 'Update',

//     clientId: '5',

//     requestInstanceId: '15225-85',

//     productInstanceId: '55889-966',

//     creatorId: '2',
//     creatorName: 'Omar',

//     data: {
//       email: {
//         old: 'aa@aa.com',

//         new: 'aa1@aa.com',
//       },

//       name: {
//         old: 'Ahmed',

//         new: 'Ali',
//       },
//       age: {
//         old: '5',

//         new: '6',
//       },
//       jj: {
//         old: 'aa@aa.com',

//         new: 'aa1@aa.com',
//       },

//       kk: {
//         old: 'Ahmed',

//         new: 'Ali',
//       },
//       ii: {
//         old: '5',

//         new: '6',
//       },
//     },

// createdAt: '2023-04-02T08:56:42.000Z',

// updatedAt: '2023-04-02T08:56:42.000Z',
//   },
//   {
//     key: '1',

//     type: 'User',

//     action: 'Delete',

//     clientId: '5',

//     requestInstanceId: '15225-85',

//     productInstanceId: '55889-966',

//     creatorId: '2',
//     creatorName: 'Moutasem',

// data: {
//   name: {
//     old: 'Omar',
//     new: '',
//   },
// },

// createdAt: '2023-04-02T08:56:42.000Z',

// updatedAt: '2023-04-02T08:56:42.000Z',
//   },
//   {
//     key: '2',

//     type: 'Request',

//     action: 'Delete',

//     clientId: '4',

//     requestInstanceId: '15225-85',

//     productInstanceId: '55889-966',

//     creatorId: '2',
//     creatorName: 'Moutasem',

// data: {
//   name: {
//     old: 'Omar',

//     new: 'Moutasem',
//   },
// },

//     createdAt: '2023-04-02T08:56:42.000Z',

//     updatedAt: '2023-04-02T08:56:42.000Z',
//   },
// ];
